import { Box, Checkbox, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Step2QuestionsProps } from '../types'
import { useStyles } from '../styles'
import { CatalogAnswerDetail } from '../../form/components/catalogAnswerDetail'

function Step2Questions({ planInfo, data, onChange }: Step2QuestionsProps) {
  const { t } = useTranslation()
  const styles = useStyles()
  const questions = planInfo.questions || []

  const handleToggleQuestion = (questionId: number) => {
    const currentSelected = data.selectedQuestions
    const isSelected = currentSelected.includes(questionId)
    const newSelected = isSelected
      ? currentSelected.filter((id) => id !== questionId)
      : [...currentSelected, questionId]

    onChange({
      selectedQuestions: newSelected,
      selectedEvidences: isSelected
        ? data.selectedEvidences.filter((item) => item.questionId !== questionId)
        : data.selectedEvidences,
    })
  }

  return (
    <Box sx={styles.step2Container}>
      <Box sx={styles.questionListContainer}>
        {questions.map((question) => {
        const isSelected = data.selectedQuestions.includes(question.id)
        return (
          <Box key={question.id} sx={[styles.questionItem, { cursor: 'pointer' }]} onClick={() => handleToggleQuestion(question.id)}>
            <Checkbox
              checked={isSelected}
              onChange={() => handleToggleQuestion(question.id)}
              color="primary"
              sx={styles.questionCheckbox}
            />
            <Box sx={styles.questionContent}>
              <Box sx={styles.questionLeft}>
                <Typography sx={styles.questionLabel}>
                  {t('actionPlan.triggerQuestion')}
                </Typography>
                <Typography sx={styles.questionText}>
                  {question.question}
                </Typography>
              </Box>
              <Box sx={styles.questionRight}>
                {question.fullAnswer?.length ? (
                  <CatalogAnswerDetail fullAnswer={question.fullAnswer} />
                ) : (
                  <>
                    <Typography sx={styles.questionLabel}>
                      {t('actionPlan.selectedAnswer')}
                    </Typography>
                    <Typography sx={styles.answerText}>
                      {question.answer}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        )
        })}
      </Box>
    </Box>
  )
}

export default Step2Questions
